module.exports = __webpack_public_path__ + "img/Phone.32a35366.png";